import "./SearchBar.css";

import { Icon, InputField, Typography } from "@saviynt/design-system";
import { type Dispatch, type SetStateAction } from "react";
import { useIntl } from "react-intl";

interface SearchBarProps {
  value: string;
  setValue: Dispatch<SetStateAction<string>>;
  dataTestId?: string;
}

export default function SearchBar({
  value,
  setValue,
  dataTestId = undefined,
}: SearchBarProps) {
  const intl = useIntl();

  return (
    <InputField
      name="searchInventory"
      placeholder={intl.formatMessage({
        defaultMessage: "Search",
        id: "XpUrPT",
        description: "Label for the search input field to find inventory items",
      })}
      label={
        <Typography htmlFor="Search" color="--color-foreground-neutral-subtle">
          {intl.formatMessage({
            defaultMessage: "Search",
            id: "XpUrPT",
            description:
              "Label for the search input field to find inventory items",
          })}
        </Typography>
      }
      kind="search"
      prefixIcon={
        <Icon
          kind="Search"
          color="--color-foreground-neutral-subtle"
          size="smallMedium"
        />
      }
      value={value}
      setValue={setValue}
      size="medium"
      ariaLabel={intl.formatMessage({
        defaultMessage: "Search inventory items",
        id: "oqXLIm",
        description: "Label for the search input field to find inventory items",
      })}
      dataTestId={dataTestId}
      className="nhi-searchbar"
    />
  );
}
